import React from "react";

function EachProject({ project }) {
  const firstImage = project.images?.[0];
  const isPlaceholder =
    !firstImage || firstImage.includes("placeholder.com");

  return (
    <div className="project-card">
      {isPlaceholder ? (
        <div className="project-card-image-placeholder">🎮</div>
      ) : (
        <img
          className="project-card-image"
          src={firstImage}
          alt={project.projectTitle}
        />
      )}

      <div className="project-card-body">
        <div className="project-card-type">{project.collaborators}</div>
        <h3 className="project-card-title">{project.projectTitle}</h3>
        <p className="project-card-desc">{project.description}</p>

        <div className="project-tech-tags">
          {project.skills.map((skill) => (
            <span key={skill} className="project-tech-tag">{skill}</span>
          ))}
        </div>

        <div className="project-card-links">
          {project.live && (
            <a
              href={project.live}
              target="_blank"
              rel="noreferrer"
              className="project-link project-link-primary"
            >
              Live Demo ↗
            </a>
          )}
          {project.sourceCode && (
            <a
              href={project.sourceCode}
              target="_blank"
              rel="noreferrer"
              className="project-link project-link-secondary"
            >
              Source Code
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default EachProject;
